import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconStep4 = createIcon({
  viewBox: '0 0 36 36',
  path: (
    <>
      <circle cx="18" cy="18" r="17.5" stroke="#0D47A1" />
      <path
        d="M21.7311 19.464C21.9231 19.464 22.0725 19.5173 22.1791 19.624C22.2858 19.72 22.3391 19.848 22.3391 20.008C22.3391 20.3707 22.1365 20.552 21.7311 20.552H20.5311V22.408C20.5311 22.6213 20.4671 22.7867 20.3391 22.904C20.2218 23.0213 20.0671 23.08 19.8751 23.08C19.6831 23.08 19.5285 23.0213 19.4111 22.904C19.2938 22.7867 19.2351 22.6213 19.2351 22.408V20.552H14.4991C14.3071 20.552 14.1578 20.4987 14.0511 20.392C13.9445 20.2853 13.8911 20.152 13.8911 19.992C13.8911 19.8427 13.9498 19.6773 14.0671 19.496L19.2991 11.928C19.4485 11.736 19.6405 11.64 19.8751 11.64C20.0565 11.64 20.2111 11.6987 20.3391 11.816C20.4671 11.9333 20.5311 12.0987 20.5311 12.312V19.464H21.7311ZM15.3791 19.464H19.2351V13.912L15.3791 19.464Z"
        fill="#0D47A1"
      />
    </>
  ),
});

export default IconStep4;
